/**
 * The `PageWrapper` function is a React component that wraps its children in a div with specific
 * styling.
 * @returns A functional component named PageWrapper is being returned. It takes a prop named children
 * and renders a div with the class name "midde_cont". Inside this div, there is another div with the
 * class name "container-fluid" and inline styles for paddingLeft and paddingRight set to "0". The
 * children components passed to PageWrapper are rendered inside this inner div.
 */
const PageWrapper = ({ children }) => {
  return (
    <div className="midde_cont">
      <div
        className="container-fluid"
        style={{ paddingLeft: "0", paddingRight: "0" }}
      >
        {children}
      </div>
    </div>
  );
};

export default PageWrapper;
